<template>
  <div class="fill-height">
    <line-chart
      v-if="viewMode === 'chart'"
      class="fill-height"
      :raw-data="sortedPlayers"
      :plot-options="{bar: {horizontal: false, borderRadius: 10, dataLabels: {position: 'top'}}}"
      :chart-value-keys="chartValueKeys"
      x-value="last_name"
      :y-value-prefix="aggregation && !removable ? 'latest_stats.' : 'player_stats.'"
      :yaxis="[{ title: { text: $t('chart_legends.minutes') }}]"
      :colors="['#008FFB']"
      :xaxis="{
        labels: {
          rotate: -45
        },
        categories: sortedPlayers.map(p => p.first_name[0] + '. ' + p.last_name ),
        tickPlacement: 'between'
      }"
      :fill="{ type: 'solid', opacity: [0.5] }"
    >
      <template v-slot:header>
        <v-card-title class="pa-6 d-flex justify-space-between">
          <div class="subtitle-2 grey--text text--grey-100">
            {{ $t('card_title.minutes_per_player') }}{{ aggregation ? ": " + $t(`variables.${aggregation}.long`) : '' }}
          </div>
          <v-btn
            v-if="removable"
            icon
            style="pointer-events: auto"
            @click="$emit('remove')"
          >
            <v-icon small>
              fal fa-times
            </v-icon>
          </v-btn>
          <visual-list-toggle
            v-else
            :value.sync="viewMode"
          />
        </v-card-title>
      </template>
    </line-chart>

    <v-card
      v-else-if="viewMode === 'table'"
      class="fill-height rounded-lg"
    >
      <v-card-title class="pa-6 d-flex justify-space-between">
        <div class="subtitle-2 grey--text text--grey-100">
          {{ $t('card_title.minutes_per_player') }}{{ aggregation ? ": " + $t(`variables.${aggregation}.long`) : '' }}
        </div>
        <div class="d-flex align-center">
          <visual-list-toggle
            v-if="!removable"
            :value.sync="viewMode"
          />
        </div>
      </v-card-title>

      <v-data-table
        :headers="tableHeaders"
        :items="players"
        hide-default-footer
        disable-pagination
        :items-per-page="-1"
        fixed-header
        :height="350"
      >
        <template v-slot:item.last_name="{ item }">
          {{ item.last_name }}, {{ item.first_name }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import LineChart from '@/components/charts/LineChart.vue'
import VisualListToggle from '@/components/buttons/VisualListToggle.vue'

export default {
  name: 'MinutesPlayedChart',
  components: { LineChart, VisualListToggle },
  props: {
    players: {
      type: Array,
      required: true
    },
    removable: {
      type: Boolean,
      default: false
    },
    aggregation: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      viewMode: 'chart'
    }
  },
  computed: {
    chartValueKeys() {
      return [
        { key: 'minutes_played', name: this.$t('scoresheet.minutes_played'), type: 'bar' }
      ]
    },
    tableHeaders() {
      return [
        { text: this.$t('table_headers.name'), value: 'last_name' },
        { text: this.$t('scoresheet.minutes_played'), value: this.aggregation && !this.removable ? 'latest_stats.minutes_played' : 'player_stats.minutes_played' }
      ]
    },
    sortedPlayers() {
      const filteredPlayers = this.players.filter(p => p.player_stats?.minutes_played)

      return [...filteredPlayers].sort((a, b) => {
        const aMinutes = a.player_stats?.minutes_played
        const bMinutes = b.player_stats?.minutes_played

        if (aMinutes === undefined || aMinutes === null) return 1
        if (bMinutes === undefined || bMinutes === null) return -1

        return bMinutes - aMinutes
      })
    }
  }
}
</script>
